import { Component, OnInit, AfterViewInit } from '@angular/core';
import { User } from '../profile.model';
import { EditProfileDialogComponent } from '../edit-profile-dialog/edit-profile-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material';
import { NewUserDialogComponent } from '../new-user-dialog/new-user-dialog.component';
import { DeleteUserDialogComponent } from '../delete-user-dialog/delete-user-dialog.component';
import { ProfileService } from '../profile.service';
import { SessionStateService } from '../../../core/services/session-state.service';
import { AlertService } from '../../../shared/components/alert/alert.service';

@Component({
  selector: 'app-profile-users',
  templateUrl: './profile-users.component.html',
  styleUrls: ['./profile-users.component.scss']
})
export class ProfileUsersComponent implements OnInit {
  loggedUser: User;
  isAdmin = false;
  loading = true;
  users: Map<string, User>;
  dialogRef: MatDialogRef<EditProfileDialogComponent>;
  newUserDialogRef: MatDialogRef<NewUserDialogComponent>;
  deleteDialogRef: MatDialogRef<DeleteUserDialogComponent>;
  AdressDialogRef: MatDialogRef<EditProfileDialogComponent>;

  constructor(private profileService: ProfileService,
    private sessionStateService: SessionStateService,
    private dialog: MatDialog,
    private alertService: AlertService) { }

  ngOnInit() {
    this.updateView();
  }

  scrollToBottom() {
    const scrollBottom = setInterval( () => {
      const elem = document.getElementById('add');
      if (elem) {
        elem.scrollIntoView();
      }
      clearInterval(scrollBottom);
    }, 1000);
  }

  updateView() {
    this.profileService.getUserPermission().subscribe(user => {
      if (user.houseAccess && user.houseAccess.permissionRole === 'Admin') {
        this.getHouseUsers();
        this.scrollToBottom();
      } else {
        this.isAdmin = false;
        this.profileService.getUser().subscribe(userDetail => {
          this.loading = false;
          if ( this.sessionStateService.getHouse()) {
            this.loggedUser = new User(this.sessionStateService.getHouse().houseId, user.houseAccess.permissionRole,
             user.receiveReport, user.receivePush, user.receiveEmail, userDetail.firstName, userDetail.lastName, userDetail.email);
          }
        });
      }
    });


  }

  getHouseUsers() {
    this.profileService.getUsers().
    finally(() => this.getYourProfile()).subscribe((Users: Map<string, User>) => {
      this.users = Users;
      this.loading = false;
    });
  }

  getUsersValues() {
    if (this.users) {
      return Array.from(this.users.values());
    }
  }

  getYourProfile() {
    this.getUsersValues().forEach(user => {
      if (user.email ===  this.sessionStateService.getUsername()) {
        this.loggedUser = user;
        this.isAdmin = user.permissionRole === 'Admin';
      }
    });
    return this.loggedUser;
  }

  editUser(user: User, isSelf: boolean) {
    this.dialogRef = this.dialog.open(EditProfileDialogComponent, {
      data: {
        user: user,
        isSelf: isSelf
      },
      autoFocus: true,
      panelClass: 'editProfilePopup'
    });
    const sub = this.dialogRef.componentInstance.action
      .subscribe((update: boolean) => {
        if (update) {
          this.updateView();
        }
      });
  }

  addNewUser() {
    this.newUserDialogRef = this.dialog.open(NewUserDialogComponent, {
      data: {
      },
      autoFocus: false,
      panelClass: 'newUserPopup'
    });
    const sub = this.newUserDialogRef.componentInstance.action
      .subscribe((update: boolean) => {
        if (update) {
          this.alertService.info('User added successfully.');
          this.updateView();
        }
      },  (err => {
        // console.log(err);
      }));
     }

   deleteUser(email: string) {
    this.deleteDialogRef = this.dialog.open(DeleteUserDialogComponent, {
      data: {
        email: email
      },
      autoFocus: false,
      panelClass: 'deleteUserPopup'
    });
    const sub = this.deleteDialogRef.componentInstance.action
      .subscribe((response: boolean) => {
        if (response) {
          return  this.profileService.removeUser(email).subscribe(res => {
            this.alertService.info('User deleted successfully.');
            this.updateView();
          });
        }
      });
   }

  showCoachMark(type) {
    return this.sessionStateService.getCoachMarkIndividualState().get(type);
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/profile/profile-users/profile-users.component.ts